import { type FC } from 'react';
import { Spinner } from 'dibs-elements/exports/Spinner.tsx';
import classnames from 'classnames';
import dibsCss from 'dibs-css';
import styles from './DropdownLoadingContent-style.scss';

const DropdownLoadingContent: FC = () => {
    return (
        <div
            className={classnames(
                styles.dropdownLoadingContent,
                dibsCss.flex,
                dibsCss.itemsCenter,
                dibsCss.justifyCenter
            )}
        >
            <Spinner dark />
        </div>
    );
};

export default DropdownLoadingContent;
